import React from 'react'

import PrivacyPolicyContent from 'components/PrivacyPolicy'
import { ThemedComponent } from 'ui/theme'
import useController from './controller'
import {
  BackLink,
  BrandLogo,
  BrandLink,
  Header,
  HeaderInner,
  Page,
  PageEyebrow,
  PageHeader,
  PageIntro,
  PageMain,
  PageTitle,
  PolicyArticle,
} from './styled'

export default function PrivacyPolicy() {
  useController()

  return (
    <ThemedComponent>
      <Page>
        <Header>
          <HeaderInner>
            <BrandLink to="/" aria-label="MagVenture Universe home">
              <BrandLogo alt="MagVenture Universe" />
            </BrandLink>
            <BackLink to="/">Back to MagVenture Universe</BackLink>
          </HeaderInner>
        </Header>

        <PageMain>
          <PageHeader>
            <PageEyebrow>Legal</PageEyebrow>
            <PageTitle>Privacy Policy</PageTitle>
            <PageIntro>How MagVenture collects, uses, stores, and protects your personal information.</PageIntro>
            <p>Last updated March 19, 2025</p>
          </PageHeader>

          <PolicyArticle>
            <PrivacyPolicyContent />
          </PolicyArticle>
        </PageMain>
      </Page>
    </ThemedComponent>
  )
}
